import { AccountCircle } from '@mui/icons-material';
import { AppBar, Container, Grid, IconButton, Menu, MenuItem, Toolbar, Typography, } from '@mui/material';
import { Box } from '@mui/system'
import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom'
// import Footer from '../pages/Footer'
import MenuIcon from '@mui/icons-material/Menu';

const MainLayout = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false)
    const navigate = useNavigate()

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        navigate('/accounts/profile')
        setAnchorEl(null);
    };


    return (
        <Box bgcolor="background.default" color="text.primary">
            {/* <AppBar position="static" color="primary" enableColorOnDark>
                <Toolbar>
                    <IconButton edge="start" color="inherit" aria-label="menu" sx={{ mr: 2, display: { md: "none" } }} onClick={() => setIsDrawerOpen(true)} >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
                        Outsource
                    </Typography>
                    <div>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleMenu}
                            color="inherit"
                        >
                            <Typography sx={{ mr: 2 }}>Osoftz</Typography>
                            <AccountCircle />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            <MenuItem onClick={handleClose}>Profile</MenuItem>
                            <MenuItem onClick={handleClose}>My account</MenuItem>
                            <MenuItem onClick={() => navigate('/accounts/signin')}>Sign out</MenuItem>
                        </Menu>
                    </div>
                </Toolbar>
            </AppBar> */}
            <Box >
                <Outlet />
            </Box>
        </Box>
    )
}

export default MainLayout